export const
    API_URL = "//serwis.elitameble.pl:779/MOZ_API/",
    //API_URL = "http://localhost:62398/",
    IS_INTERNAL_APP = true;



// WEBPACK FOOTER //
// ./src/api/ApiSettings.js